import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "../ui/skeleton";
export const FaqLoader = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [...Array(7)].map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="flex w-full flex-1 flex-col gap-2">{t0}<div className="flex items-center justify-center gap-2 pb-px"><Skeleton className="h-10 w-32" /></div><span role="status" className="sr-only">Loading...</span></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(_, i) {
  return <Skeleton key={i} className="h-11 w-full" />;
}